import React, { useEffect, useState } from 'react'
import { Paper } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

export const createArray = (key, value) => {
    return { key, value }
}

let rowItems = [];

function MateInfo(props) {
    const { t } = useTranslation();
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        rowItems = [
            createArray('CONTENT.MY-MATES.DEVICE.DEVICE-BODY.DEFAULT-DEVICE', props.data.is_default_device),
            createArray('CONTENT.MY-MATES.DEVICE.DEVICE-BODY.LOCAL-DEVICE', props.data.is_local_device),
            createArray('CONTENT.MY-MATES.DEVICE.DEVICE-BODY.RAM', props.data.device_ram),
            createArray('CONTENT.MY-MATES.DEVICE.DEVICE-BODY.DEVICE-OS', props.data.device_os),
            createArray('CONTENT.MY-MATES.DEVICE.DEVICE-BODY.DEVICE-CPU', props.data.device_cpu),
        ]
        setLoaded(true)
    }, [])

    return (
        <div className="info-body-detail">
            {
                loaded && rowItems.map((item, itemI) => {
                    return (
                        <div key={itemI} className='info-body-row'>
                            <div className='info-body-row-key'>
                                {t(item.key)}
                            </div>
                            <div className='info-body-row-value'>
                                {item.value}
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default MateInfo
